import React, { Component } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { TextField } from "@mui/material";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';

/*Components*/
import ButtonAction from '../../../Components/Buttons/ButtonAction'
import ButtonSend from '../../../Components/Buttons/ButtonSend'
import ButtonCancel from '../../../Components/Buttons/ButtonCancel'
import Pagination from '../../../Components/Table/Utils/Pagination'
import CsLoader from '../../../Components/Loading/Loader' 

/* Properties */
import Countries from '../../../../Controller/Generic/getCountries'
import {getusers, getroles} from '../../../../Controller/Custom/Management/get'
import PutUsers from '../../../../Controller/Custom/Management/put'
import DeleteUsers from '../../../../Controller/Custom/Management/delete'
import Alert from '../../../Components/Alerts/message'

/* Table Header */
import datas from './Data/THeader'

/* Styles */
import 'bootstrap/dist/css/bootstrap.min.css'
import './UserMaintenance.css'

class UserManagement extends Component {
    constructor(props) {
        super(props);
        this.state={
            isloading: false,
            modaltype: 'A',
            pagination: {
                currentpage: 1,
                recordperpage: 10
            },
            searchTerm: '',
            alerts: {
                open: false,
                severity: '',
                message: ''
            },
            modals:{
                iscreatemodalopen: false,
                isdeletemodalopen: false,
                deletemodal: {
                    title: '',
                    message: ''
                },
            },
            user: props?.user,
            ssdata:{
                id: '',
                value: '',
                name: ''
            },
            gsdata:{
                countries:[],
                roles:[],
                activo:[]
            },
            getdata:[],
            createdata:{
                Nombre: '',
                Login: '',
                IdRol: '',
                Email: '',
                IdPais: '',
                Country:'',
                Activo: 0,
                FechaInsercion: new Date(),
                UsuarioInsercion: '',
                FechaModificacion: new Date(),
                UsuarioModificacion: ''
            },
            credentialchange: {
                Password: '',
                Username: ''
            },
            selectdata: {
                id: ''
            }    
        };
        this.handleCRChange = this.handleCRChange.bind(this);
        this.handleCRChangeMultiSelect = this.handleCRChangeMultiSelect.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this)
      }

    // Event for open modal that it's used for add new user.
    openModal=()=>{
        this.setState({modals: {iscreatemodalopen: !this.state.modals.iscreatemodalopen }})
    }

    // get data period
    getData=async() =>{
        const countries = await Countries(this.state.user);
        let response = await getusers();
        if(response.status === 200) {
            let datas = []
            response.data.respuesta.forEach((user) => {
                const names = countries.respuesta
                .filter(country => user.Pais.includes(parseInt(country.Id)))
                .map(country => country.Nombre)
                .join(',');
  
                let data = {
                    Username: user.Nombre,
                    Login: user.Nombre,
                    Rol: user.Rol,
                    Mail: user.Email,
                    Country: names,
                    Activo: user.activo == 0 ? 'Inactive' : 'Active',
                }
 
                datas.push(data)
            })
            
            this.setState({
                getdata: datas,
                isloading: false
            });
        } else{
            this.setState({
                getdata: [],
                isloading: false
            });
        }
    }

    // select data period
    selectData=(data)=>{
        this.setState({
            selectdata: {
                id: data.Id,
            },
            createdata: {
                Nombre: data.Nombre,
                Login: data.Nombre,
                Rol: data.Rol,
                Mail: data.Mail,
                Pais: data.Country,
                Country: data.Country,
                Activo: data.Activo,
                FechaInsercion: new Date(),
                UsuarioInsercion: this.state.user?.email,
                FechaModificacion: new Date(),
                UsuarioModificacion: this.state.user?.email
            }
        });

        console.log(this.state.selectdata); 
    }

    deleteData=async()=>{
        let response = await DeleteUsers(this.state.createdata.Mail);
        if(response.status !== 200) {
            this.setState({alerts: {
                open: true,
                severity: 'error',
                message: response.data.mensaje
             }});
        }else{
            this.setState({alerts: {
                open: true,
                severity: 'success',
                message: response.data.mensaje
             }});
        }
        this.getData();
        this.setState({modals: {isdeletemodalopen: false }});
    }

    putData=async()=>{
        let roles =  this.state.gsdata.roles;
        const rolId = roles
            .filter(rol => this.state.createdata.Rol.includes(rol.Rol))
            .map(rol => parseInt(rol.Id))[0];

        let countries = this.state.gsdata.countries;
        const countryIds = countries
            .filter(country => this.state.createdata.Country.includes(country.Nombre))
            .map(country => parseInt(country.Id));
      
        let formulary={
            Email: this.state.createdata.Mail,
            Pais: countryIds,
            Rol: rolId,
            activo: this.state.createdata.Activo == 'Active' ? 1 : 0
        }

        let response = await PutUsers(formulary)
        if(response.codigo !== 200) {
            this.setState({alerts: {
                open: true,
                severity: 'error',
                message: response.data.mensaje
             }});
        }else{
            this.setState({alerts: {
                open: true,
                severity: 'success',
                message: response.mensaje
             }});
        }

        this.getData();
        this.openModal();
    }

    handleSearchChange(event) {
        this.setState({ searchTerm: event.target.value })
    }
    
    handleCRChangeMultiSelect=async(event, values)=>{
        let countriesId = '';
        values.map(element => {
            if(countriesId === '') {
                countriesId = element.Nombre
            } else {
                countriesId = countriesId + ',' + element.Nombre
            }
        });
        this.setState({
            createdata:{
                ...this.state.createdata,
                Country: countriesId,
            }
        });

        console.log(this.state.createdata);
    }
    
    handleCRChange=async(event)=>{
        this.setState({
            createdata:{
                ...this.state.createdata,
                [event.target.name]: event.target.value,
                FechaInsercion: new Date(),
                UsuarioInsercion: this.state.user?.email,
                FechaModificacion: new Date(),
                UsuarioModificacion: this.state.user?.email,
            }
        });

        console.log(this.state.createdata);
    }

    handleCloseAlert() {
        this.setState({alerts: {open: false }});
    }

    pageRender(page) {
        this.setState({
            pagination: {
                currentpage: page
            }
        });
    }

    tableRender(currentData) {
        return currentData.length > 0 ?
            this.tableBodyRender(currentData)
            : this.tableDataNotFound();
    }

    tableBodyRender(currentData) {
        return currentData.map((user, index) => {
            return (
                <tr key={user.Id}>
                    <td>{user.Login}</td>
                    <td>{user.Rol}</td>
                    <td>{user.Country}</td>
                    <td>
                        <ButtonAction
                            canEdit={true}
                            canDelete={true}
                            canSeeDetails={false}
                            editRow={() => { this.selectData(user); this.setState({ modaltype: 'U' }); this.openModal(); } }
                            deleteRow={() => { this.selectData(user); this.setState({ modals: { isdeletemodalopen: true } }); } }
                            detailRow={''} />
                    </td>
                </tr>
            );
        });
    }

    tableDataNotFound() {
        return <tr><td colSpan={6} style={{ borderBottom: "0px", textAlign: "left" }}><div style={{ background: 'white' }}>Not have registers.</div></td></tr>;
    }
    
    componentDidMount=async()=>{
        this.setState({isloading: true});
        let countryresponse = await Countries(this.state.user);
        let roleresponse = await getroles();

        this.setState({
            gsdata: {
                countries: countryresponse.codigo === 200 ? countryresponse.respuesta : [],
                roles: roleresponse.data.respuesta ?? [],
                activo: [
                    {
                        Activo: 1,
                        Nombre: "Active"
                    },
                    {
                        Activo: 0,
                        Nombre: "Inactive"
                    },
                ]
            }
        });

        this.getData();
    }

    render(){

        // 1. Normalizamos el término de búsqueda
        const term = this.state.searchTerm.toLowerCase();

        // 2. Filtramos la data según Login, Mail o Country
        const filtered = this.state.getdata.filter(u => 
        u.Login.toLowerCase().includes(term) ||
        u.Mail.toLowerCase().includes(term) ||
        u.Country.toLowerCase().includes(term)
        );

        // 3. Ordenamos el resultado filtrado por fecha (descendente)
        const sorted = filtered.sort(
        (a, b) => convertToDate(b.UserCreateDate) - convertToDate(a.UserCreateDate)
        );

        // 4. Paginación sobre el listado filtrado y ordenado
        const indexOfLast = this.state.pagination.currentpage * 10;
        const indexOfFirst = indexOfLast - 10;
        const currentData = sorted.slice(indexOfFirst, indexOfLast);

        // 5. Número de páginas también con base en la data filtrada
        const nPages = Math.ceil(filtered.length / 10);

        const countries = this.state.gsdata.countries;
        return(
            <div>
                <div>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            fullWidth
                            id="search"
                            name="search"
                            variant="outlined"
                            label="Buscar usuario"
                            value={this.state.searchTerm}
                            onChange={this.handleSearchChange}
                        />
                    </Box>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                {datas.map((data, index) => {
                                    return(<th key={data.name} className=''>{data.name}</th>)
                                })}
                            </tr>
                        </thead>
                        <tbody>	
                            {this.state.isloading === false
                                ? this.tableRender(currentData) 
                                : <CsLoader />
                            }
                        </tbody>
                    </table>
                    <Pagination pagesCount={nPages} currentPage={this.state.pagination.currentpage} setCurrentPage={this.pageRender.bind(this)}/>
                    <Modal isOpen={this.state.modals.iscreatemodalopen}>
                        <ModalHeader style={{display: 'block', backgroundColor: '#081c42', color: 'white'}}>
                            <span style={{float: 'right'}} onClick={()=>this.openModal()}>x</span>
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <div className='mb-bt15'>
                                    <div className='mb-10'>
                                        <Box sx={{ maxWidth: '100%' }}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    fullWidth
                                                    id="Mail"
                                                    name="Mail"
                                                    variant="outlined"
                                                    label="Mail User"
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                    defaultValue={this.state.createdata?.Mail}
                                                    onChange={this.handleCRChange}
                                                    />
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div className='mb-10'>
                                        <Box sx={{ maxWidth: '100%' }}>
                                            <FormControl fullWidth>
                                                <InputLabel id="rolUser">Rol User</InputLabel>
                                                <Select
                                                    labelId="rolUser"
                                                    id="Rol"
                                                    name="Rol"
                                                    label="Rol User"
                                                    defaultValue={this.state.createdata?.Rol}
                                                    onChange={this.handleCRChange}
                                                    >
                                                        {this.state.gsdata.roles.map((country, index) => {
                                                        return(
                                                            <MenuItem key={country.Rol} value={country.Rol}>{country.Rol}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div className='mb-10'>
                                        <Box sx={{ maxWidth: '100%' }}>
                                            <FormControl fullWidth>
                                                 {this.state.createdata?.Rol === "Country User" 
                                                    || this.state.createdata?.Rol === "Corporate User"
                                                    || this.state.createdata?.Rol === "Admin"
                                                    || this.state.createdata?.Rol === "Reading User" ?
                                                      <>
                                                      <InputLabel id="countrylabel">Country</InputLabel>
                                                      <Select
                                                          labelId="countrylabel"
                                                          id="Country"
                                                          name="Country"
                                                          label="Country"
                                                          value={this.state.createdata?.Country}
                                                          onChange={this.handleCRChange}
                                                          >
                                                          {this.state.gsdata.countries.sort((a, b) => a.Nombre > b.Nombre).map((country, index)=> {
                                                              return(
                                                                  <MenuItem key={country.Id} value={country.Nombre}>{country.Nombre}</MenuItem>
                                                              )
                                                          })}
                                                      </Select>
                                                  </>                                                
                                                :
                                                    <Autocomplete
                                                        multiple
                                                        id="country"
                                                        options={this.state.gsdata.countries}
                                                        getOptionLabel={(option) => option.Nombre}
                                                        defaultValue={getCountriesByRole(this.state.createdata?.Country, this.state.gsdata.countries, this.state.modaltype) ?? []}
                                                        onChange={this.handleCRChangeMultiSelect}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Country"
                                                            />
                                                        )}
                                                    />
                                                }
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div className='mb-10'>
                                        <Box sx={{ maxWidth: '100%' }}>
                                            <FormControl fullWidth>
                                                <InputLabel id="activo">User Status</InputLabel>
                                                <Select
                                                    labelId="activo"
                                                    id="Activo"
                                                    name="Activo"
                                                    label="Activo"
                                                    defaultValue={this.state.createdata?.Activo}
                                                    onChange={this.handleCRChange}
                                                    >
                                                        {this.state.gsdata.activo.map((active, index) => {
                                                        return(
                                                            <MenuItem key={active.Nombre} value={active.Nombre}>{active.Nombre}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            {this.state.modaltype === 'A' ?
                                <ButtonSend event={()=>this.postData()} name="Send Data" />
                                : <ButtonSend event={()=>this.putData()} name="Update" />
                            }
                            <ButtonCancel event={()=>this.openModal()} name="Cancel" />
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.modals.isdeletemodalopen}>
                        <ModalBody>
                            Are you sure that you want delete the following User?
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={()=>this.deleteData()}>Yes</button>
                            <button className="btn btn-secundary" onClick={()=>this.setState({modals: {isdeletemodalopen: false }})}>No</button>
                        </ModalFooter>
                    </Modal>
                    <Alert open={this.state.alerts.open} severity={this.state.alerts.severity} message={this.state.alerts.message} event={this.handleCloseAlert.bind(this)}/>
                </div>
            </div>
        )

        function convertToDate(data){
            let date = new Date(data);
            return date.getFullYear() + "-" + date.getMonth() + "-" + date.getDay();
        }
    }
}

const getCountriesByRole = (country, data, modaltype) => {
    if(modaltype === "U") {
        if(country?.includes(',')) {
            let countries = country.split(',');
            return data.filter((e) => {return countries.includes(e?.Nombre)});
        }else {
            return data.filter((e) => {return e?.Nombre === country})
        }
    }
}


export default UserManagement